import { render, staticRenderFns } from "./ComprehensiveWebSocketTest.vue?vue&type=template&id=1d3938ec&scoped=true"
import script from "./ComprehensiveWebSocketTest.vue?vue&type=script&lang=js"
export * from "./ComprehensiveWebSocketTest.vue?vue&type=script&lang=js"
import style0 from "./ComprehensiveWebSocketTest.vue?vue&type=style&index=0&id=1d3938ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3938ec",
  null
  
)

export default component.exports